import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

export const initProjectsCarousel = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".projects-carousel__swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((sliderElement) => {
    const wrapper = sliderElement.closest(".projects-carousel__slider-wrapper");
    const nextBtn = wrapper?.querySelector(
      ".ea-slider-nav--next",
    ) as HTMLElement;
    const prevBtn = wrapper?.querySelector(
      ".ea-slider-nav--prev",
    ) as HTMLElement;

    new Swiper(sliderElement, {
      modules: [Navigation, Autoplay],
      loop: false, // Set to true if you want infinite scrolling
      spaceBetween: 30,
      grabCursor: true,
      watchOverflow: true,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      breakpoints: {
        320: { slidesPerView: 1.2, spaceBetween: 15 },
        768: { slidesPerView: 2.2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
      },
    });
  });

  console.log("[ProjectsCarousel] Initialized.");
};
